import React, { useEffect } from "react";
import { useUser } from "../contexts/UserContext";
import { useNavigate, useLocation } from "react-router";
import { NavbarPortal } from "@sciencecorp/helix-components";
import { Page } from "./UI/layout";
import { Box, MenuItem, VisuallyHidden, HStack } from "@chakra-ui/react";
import { FooterPortal } from "@sciencecorp/helix-components";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "./i18n/LanguageSwitcher";
import { useLocalePrefix } from "../hooks/useLocalizedNavigate";
import { SupportedLocale } from "@/i18n/config";

const App: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { loggedIn, user, login, logout } = useUser();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation("common");
  const localePrefix = useLocalePrefix();

  const redirectTo = localStorage.getItem("redirect_to");
  useEffect(() => {
    if (redirectTo && user) {
      localStorage.removeItem("redirect_to");
      navigate(redirectTo);
    }
  }, [navigate, redirectTo, user]);

  const subNavItems = [
    {
      label: t("nav.application"),
      href: `${localePrefix}/registry`,
    },
  ];

  const renderedUser = loggedIn
    ? {
        name: user?.email,
        picture: undefined,
        url: undefined,
        has_notifications: false,
        children: user?.is_admin ? (
          <MenuItem as={Link} to={`${localePrefix}/admin`}>
            {t("nav.admin")}
          </MenuItem>
        ) : undefined,
      }
    : undefined;

  return (
    <>
      <VisuallyHidden>
        <a href="#page-content">{t("nav.skipToContent")}</a>
      </VisuallyHidden>
      <Box justifyContent="space-between" display="flex" flexDirection="column" minHeight="100vh">
        <Box position="relative">
          <NavbarPortal
            title={t("nav.patientRegistry")}
            user={renderedUser}
            homeUrl={`${localePrefix}/`}
            authedItems={subNavItems}
            onLogin={login}
            onLogout={logout}
            items={[{ component: <LanguageSwitcher /> }]}
            language={i18n.language as SupportedLocale}
          />
        </Box>
        <Page flexGrow={1}>{children}</Page>
        <FooterPortal showPRIMADisclaimer showPrivacyContact />
      </Box>
    </>
  );
};

export default App;
